import React from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function WhoWeAre() {
  const [contentRef, contentVisible] = useScrollAnimation();
  const [card1Ref, card1Visible] = useScrollAnimation();
  const [card2Ref, card2Visible] = useScrollAnimation();
  const [card3Ref, card3Visible] = useScrollAnimation();
  const [card4Ref, card4Visible] = useScrollAnimation();
  const { t } = useTranslation();

  return (
    <div className="whoweare-wrapper">
      <div className="whoweare container flex">
        <div
          ref={contentRef}
          className={`whoweare-content ${contentVisible ? "animate-in" : ""}`}
        >
          <div className="flex">
            <div className="circle"></div>
            <h4 className="clr-green fs-700">{t("whoWeAre.aboutUs")}</h4>
          </div>
          <h2 className="fs-900 clr-dark">{t("whoWeAre.title")}</h2>
          <p className="clr-gray fs-500">{t("whoWeAre.description")}</p>
          <Link to="/about">
            <button className="fs-500 clr-white transition pointer">
              {t("whoWeAre.learnMore")}
            </button>
          </Link>
        </div>
        <div className="whoweare-grid">
          <div
            ref={card1Ref}
            className={`whoweare-card animate-from-top ${
              card1Visible ? "animate-in" : ""
            }`}
          >
            <img src="/assets/icons/profileIcon.svg" alt="Profile Icon" />
            <h3 className="fs-800">62+</h3>
            <p className="fs-400">{t("whoWeAre.yearsOfExperience")}</p>
          </div>
          <div
            ref={card2Ref}
            className={`whoweare-card green clr-white animate-from-right ${
              card2Visible ? "animate-in" : ""
            }`}
          >
            <img src="/assets/icons/calendarIcon.svg" alt="Calendar Icon" />
            <h3 className="fs-800">30k+</h3>
            <p className="fs-400">{t("whoWeAre.projectsPerYear")}</p>
          </div>
          <div
            ref={card3Ref}
            className={`whoweare-card green clr-white animate-from-left ${
              card3Visible ? "animate-in" : ""
            }`}
          >
            <img src="/assets/icons/happyIcon.svg" alt="Happy Icon" />
            <h3 className="fs-800">100%</h3>
            <p className="fs-400">{t("whoWeAre.clientSatisfaction")}</p>
          </div>
          <div
            ref={card4Ref}
            className={`whoweare-card animate-from-bottom ${
              card4Visible ? "animate-in" : ""
            }`}
          >
            <img src="/assets/icons/peopleIcon.svg" alt="People Icon" />
            <h3 className="fs-800">10k+</h3>
            <p className="fs-400">{t("whoWeAre.tradesPerYear")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhoWeAre;
